// extracted by mini-css-extract-plugin
export var container = "avatar-module--container--dD9a5";
export var large = "avatar-module--large--rpvcv";
export var medium = "avatar-module--medium--DPrwv";
export var ratioBox = "avatar-module--ratio-box--MovpE";
export var small = "avatar-module--small--F2PwV";